import styled from 'styled-components'

const ResetPasswordStyle = styled.div`
	--resetPasswordTitleMarginBottom: var(--sp4x);
	--contentWrapWidth: var(--sp131x);
	--resetPasswordSubtitleMaxWidth: var(--sp111x);
	--resetPasswordSubtitleMarginBottom: var(--sp8x);
	--formItemMarginBottom: var(--sp6x);
	--formLowerWrapMarginTop: var(--sp2x);
	--resetPasswordLogoTop: var(--sp5x);
	--resetPasswordLogoLeft: var(--sp9x);

	--circleWidthAndHeight: var(--sp10x);
	--successIconSizes: var(--sp4x);
	--passwordChangedMargin: var(--sp8x) 0 var(--sp5x) 0;
	--loginButtonMarginTop: var(--sp6x);
	--passwordChangedSubtitleMaxWidth: var(--sp118x);

	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;

	.reset-password-logo {
		position: absolute;
		top: var(--resetPasswordLogoTop);
		left: var(--resetPasswordLogoLeft);
	}

	.content-wrap {
		width: var(--contentWrapWidth);

		.ant-form {
			.hidden {
				height: 0;
				margin: 0;
			}

			.ant-form-item {
				margin-bottom: var(--formItemMarginBottom);
			}
		}

		.reset-password-title {
			text-align: center;
			margin-bottom: var(--resetPasswordTitleMarginBottom);
		}

		.reset-password-subtitle {
			margin: 0 auto 0;
			text-align: center;
			max-width: var(--resetPasswordSubtitleMaxWidth);
			margin-bottom: var(--resetPasswordSubtitleMarginBottom);
		}

		.form-lower-wrap {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			margin-top: var(--formLowerWrapMarginTop);

			.link-wrap {
				display: flex;

				.login-link {
					margin-left: var(--sp1x);
				}
			}
		}
	}

	.success-message,
	.resend-message {
		display: flex;
		flex-direction: column;
		align-items: center;

		.resend-text {
			margin-top: var(--sp1x);
		}

		.circle {
			display: flex;
			justify-content: center;
			align-items: center;
			width: var(--circleWidthAndHeight);
			height: var(--circleWidthAndHeight);
			border-radius: 50%;

			.success-icon {
				color: var(--primaryColor3);
				font-size: var(--successIconSizes);
				cursor: default;
			}
		}

		.password-changed-title,
		.expired-changed-title {
			margin: var(--passwordChangedMargin);
		}

		.password-changed-subtitle,
		.expired-changed-title {
			text-align: center;
			max-width: var(--passwordChangedSubtitleMaxWidth);
		}

		.login-button,
		.resend-button {
			margin-top: var(--loginButtonMarginTop);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--resetPasswordTitleMarginBottom: var(--sp4x);
		--contentWrapWidth: var(--sp98x);
		--resetPasswordSubtitleMaxWidth: var(--sp96x);
		--resetPasswordSubtitleMarginBottom: var(--sp5x);
		--formItemMarginBottom: var(--sp5x);
		--formLowerWrapMarginTop: var(--sp1x);
		--resetPasswordLogoTop: var(--sp4x);
		--resetPasswordLogoLeft: var(--sp7x);

		--circleWidthAndHeight: var(--sp8x);
		--successIconSizes: var(--sp3x);
		--passwordChangedMargin: var(--sp7x) 0 var(--sp4x) 0;
		--loginButtonMarginTop: var(--sp6x);
		--passwordChangedSubtitleMaxWidth: var(--sp89x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--resetPasswordTitleMarginBottom: var(--sp3x);
		--contentWrapWidth: var(--sp77x);
		--resetPasswordSubtitleMaxWidth: var(--sp96x);
		--resetPasswordSubtitleMarginBottom: var(--sp5x);
		--formItemMarginBottom: var(--sp4x);
		--formLowerWrapMarginTop: var(--sp1x);
		--resetPasswordLogoTop: var(--sp3x);
		--resetPasswordLogoLeft: var(--sp5x);

		--circleWidthAndHeight: var(--sp8x);
		--successIconSizes: var(--sp3x);
		--passwordChangedMargin: var(--sp7x) 0 var(--sp4x) 0;
		--loginButtonMarginTop: var(--sp6x);
		--passwordChangedSubtitleMaxWidth: var(--sp76x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--resetPasswordTitleMarginBottom: var(--sp3x);
		--contentWrapWidth: var(--sp73x);
		--resetPasswordSubtitleMaxWidth: var(--sp96x);
		--resetPasswordSubtitleMarginBottom: var(--sp4x);
		--formItemMarginBottom: var(--sp4x);
		--formLowerWrapMarginTop: var(--sp1x);
		--resetPasswordLogoTop: var(--sp3x);
		--resetPasswordLogoLeft: var(--sp4x);

		--circleWidthAndHeight: var(--sp8x);
		--successIconSizes: var(--sp3x);
		--passwordChangedMargin: var(--sp7x) 0 var(--sp4x) 0;
		--loginButtonMarginTop: var(--sp6x);
		--passwordChangedSubtitleMaxWidth: var(--sp76x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--resetPasswordTitleMarginBottom: var(--sp3x);
		--contentWrapWidth: var(--sp71x);
		--resetPasswordSubtitleMaxWidth: var(--sp96x);
		--resetPasswordSubtitleMarginBottom: var(--sp4x);
		--formItemMarginBottom: var(--sp4x);
		--formLowerWrapMarginTop: var(--sp1x);
		--resetPasswordLogoTop: var(--sp3x);
		--resetPasswordLogoLeft: var(--sp4x);

		--circleWidthAndHeight: var(--sp8x);
		--successIconSizes: var(--sp3x);
		--passwordChangedMargin: var(--sp6x) 0 var(--sp3x) 0;
		--loginButtonMarginTop: var(--sp5x);
		--passwordChangedSubtitleMaxWidth: var(--sp75x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--resetPasswordTitleMarginBottom: var(--sp3x);
		--contentWrapWidth: var(--sp60x);
		--resetPasswordSubtitleMaxWidth: var(--sp96x);
		--resetPasswordSubtitleMarginBottom: var(--sp4x);
		--formItemMarginBottom: var(--sp4x);
		--formLowerWrapMarginTop: 0;
		--resetPasswordLogoTop: var(--sp3x);
		--resetPasswordLogoLeft: var(--sp4x);

		--circleWidthAndHeight: var(--sp8x);
		--successIconSizes: var(--sp3x);
		--passwordChangedMargin: var(--sp6x) 0 var(--sp3x) 0;
		--loginButtonMarginTop: var(--sp5x);
		--passwordChangedSubtitleMaxWidth: var(--sp75x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--resetPasswordTitleMarginBottom: var(--sp3x);
		--contentWrapWidth: var(--sp65x);
		--resetPasswordSubtitleMaxWidth: var(--sp60x);
		--resetPasswordSubtitleMarginBottom: var(--sp4x);
		--formItemMarginBottom: var(--sp4x);
		--formLowerWrapMarginTop: 0;
		--resetPasswordLogoTop: var(--sp3x);
		--resetPasswordLogoLeft: var(--sp4x);

		--circleWidthAndHeight: var(--sp8x);
		--successIconSizes: var(--sp3x);
		--passwordChangedMargin: var(--sp6x) 0 var(--sp3x) 0;
		--loginButtonMarginTop: var(--sp5x);
		--passwordChangedSubtitleMaxWidth: var(--sp75x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--resetPasswordTitleMarginBottom: var(--sp3x);
		--contentWrapWidth: var(--sp45x);
		--resetPasswordSubtitleMaxWidth: var(--sp96x);
		--resetPasswordSubtitleMarginBottom: var(--sp4x);
		--formItemMarginBottom: var(--sp3x);
		--formLowerWrapMarginTop: var(--sp1x);
		--resetPasswordLogoTop: var(--sp2x);
		--resetPasswordLogoLeft: var(--sp3x);

		--circleWidthAndHeight: var(--sp7x);
		--successIconSizes: var(--sp2x);
		--passwordChangedMargin: var(--sp4x) 0 var(--sp2x) 0;
		--loginButtonMarginTop: var(--sp4x);
		--passwordChangedSubtitleMaxWidth: var(--sp47x);
	}
`

export default ResetPasswordStyle
